import * as angular from 'angular';

export interface SHIPPER_PREMIUM_SERVICES_FEATURES {
    label: string;
    enabled: number[];
}

angular.module('app').constant('SHIPPER_PREMIUM_SERVICES_FEATURES', [
    {
        label: 'Successful bid confirmations',
        enabled: [0, 1, 2]
    },
    {
        label: 'FCFS confirmations',
        enabled: [0, 1, 2]
    },
    {
        label: 'Secondary trade confirmations',
        enabled: [0, 1, 2]
    },
    {
        label: 'TSO master data',
        enabled: [1, 2]
    },
    {
        label: 'Network point data',
        enabled: [1, 2]
    },
    {
        label: 'Past auction data',
        enabled: [1, 2]
    },
    {
        label: 'Live auction data',
        enabled: [1, 2]
    },
    {
        label: 'Portfolio code data',
        enabled: [2]
    },
    {
        label: 'Balancing group data',
        enabled: [2]
    },
    {
        label: 'Bid submission',
        enabled: [2]
    },
    {
        label: 'Access to test environment',
        enabled: [2]
    }
] as SHIPPER_PREMIUM_SERVICES_FEATURES[]);
